import { render, staticRenderFns } from "./conversation-thread.vue?vue&type=template&id=23763f75"
import script from "./conversation-thread.vue?vue&type=script&lang=js"
export * from "./conversation-thread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Loader.vue').default,MessageSingle: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/MessageSingle.vue').default,ErrorBlock: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ErrorBlock.vue').default,FileUploadClient: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/FileUploadClient.vue').default,RedactorInput: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/RedactorInput.vue').default,Avatar: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Avatar.vue').default,AccountSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/AccountSelector.vue').default,InfoBoxClientNoLogins: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/InfoBoxClientNoLogins.vue').default})
